var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.layout)?_c('div',{staticClass:"app-reports"},_vm._l((_vm.layout),function(item,itemIndex){return _c('ReportComponent',{key:itemIndex,attrs:{"item":item,"reportsData":_vm.data}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }